/**
 * 🚀 MOZTECH Cinematic Homepage Intro
 * Premium Apple-level sequence animation for index page
 */
document.addEventListener("DOMContentLoaded", () => {
    if (typeof gsap === 'undefined') return;

    // Only apply the dramatic intro on the homepage
    if (!document.body.classList.contains('template-index')) return;
    if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;

    const tl = gsap.timeline({ defaults: { ease: "power4.out" } });
    
    // Selectors
    const leadVisual = Array.from(document.querySelectorAll(
        '.moztech-bubbles-section, .moztech-hero-container, .slideshow'
    )).find((element) => element.getClientRects().length > 0);
    const leadSlideshow = leadVisual?.matches('.slideshow') ? leadVisual : null;
    const heroContent = leadSlideshow
        ? leadSlideshow.querySelectorAll('.slideshow__text-wrapper .slideshow__heading, .slideshow__text-wrapper .slideshow__subheading, .slideshow__text-wrapper .button')
        : [];
    const heroMedia = leadSlideshow?.querySelector('.slideshow__media') || null;

    // 1. Initial States (Hide things before reveal)
    if (heroMedia) gsap.set(heroMedia, { scale: 1.05, filter: 'blur(6px)', opacity: 0 });
    if (heroContent.length > 0) gsap.set(heroContent, { y: 30, opacity: 0 });

    // Keep native document scrolling available throughout the reveal. This
    // legacy slideshow intro must never own the homepage scroll lifecycle.

    // 2. Play animation upon full visual load
    window.addEventListener("load", () => {
        // Smooth Video/Image reveal
        if (heroMedia) {
            tl.to(heroMedia, { scale: 1, filter: 'blur(0px)', opacity: 1, duration: 2.4, ease: "power2.inOut" }, 0.2);
        }

        // Gentle Typography reveal for Slogan
        if (heroContent.length > 0) {
            tl.to(heroContent, { 
                y: 0, 
                opacity: 1, 
                duration: 1.6, 
                stagger: 0.1,
                ease: "power4.out"
            }, "-=1.8");
        }

        // Unlock scrolling gracefully
        tl.call(() => {
            document.body.style.overflow = '';
            document.documentElement.style.overflow = '';
            if (typeof ScrollTrigger !== 'undefined' && ScrollTrigger.getAll().length > 0) {
                ScrollTrigger.refresh();
            }
        });
    });
});
